{
  "CONTACTS_FILTER": {
    "TITLE": "연락처 필터",
    "SUBTITLE": "아래에 필터를 추가하고 '제출'을 눌러 연락처를 필터링하십시오.",
    "EDIT_CUSTOM_SEGMENT": "세그먼트 편집",
    "CUSTOM_VIEWS_SUBTITLE": "필터를 추가하거나 제거하고 세그먼트를 업데이트하십시오.",
    "ADD_NEW_FILTER": "필터 추가하기",
    "CLEAR_ALL_FILTERS": "모든 필터 지우기",
    "FILTER_DELETE_ERROR": "적어도 하나 이상의 필터가 있어야 저장됩니다.",
    "SUBMIT_BUTTON_LABEL": "제출",
    "UPDATE_BUTTON_LABEL": "세그먼트 업데이트",
    "CANCEL_BUTTON_LABEL": "취소",
    "CLEAR_BUTTON_LABEL": "필터 제거하기",
    "EMPTY_VALUE_ERROR": "값이 필요합니다.",
    "SEGMENT_LABEL": "세그먼트 이름",
    "SEGMENT_QUERY_LABEL": "세그먼트 쿼리",
    "TOOLTIP_LABEL": "연락처 필터",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "와/과",
      "OR": "혹은"
    },
    "OPERATOR_LABELS": {
      "equal_to": "동일한",
      "not_equal_to": "비동일한",
      "contains": "포함된",
      "does_not_contain": "포함되지 않은",
      "is_present": "현존하는",
      "is_not_present": "현존하지 않은",
      "is_greater_than": "보다 큰",
      "is_lesser_than": "보다 작은",
      "days_before": "x일 전에"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "값이 필요합니다."
    },
    "ATTRIBUTES": {
      "NAME": "이름",
      "EMAIL": "이메일",
      "PHONE_NUMBER": "휴대폰 번호",
      "IDENTIFIER": "식별자",
      "CITY": "도시",
      "COUNTRY": "국가",
      "CUSTOM_ATTRIBUTE_LIST": "리스트",
      "CUSTOM_ATTRIBUTE_TEXT": "텍스트",
      "CUSTOM_ATTRIBUTE_NUMBER": "숫자",
      "CUSTOM_ATTRIBUTE_LINK": "링크",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "체크박스",
      "CREATED_AT": "생성일",
      "LAST_ACTIVITY": "최근 활동",
      "REFERER_LINK": "리퍼러 링크",
      "BLOCKED": "차단됨",
      "LABELS": "라벨"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "기본 필터",
      "ADDITIONAL_FILTERS": "추가 필터",
      "CUSTOM_ATTRIBUTES": "사용자 지정 특성"
    }
  }
}
